import React, { useEffect, useState } from 'react';
import { Article } from '../types/ArticleTypes';
import { useNavigate } from "react-router-dom";
import apiHelper from '../../api/ApiHelper';
import './ArticleList.css';

const ArticleList: React.FC = () => {
    const [articles, setArticles] = useState<Article[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchArticles = async () => {
            try {
                const data = await apiHelper.fetchArticles();
                setArticles(data);
                setLoading(false);
            } catch (err) {
                setError('Failed to fetch articles');
                setLoading(false);
            }
        };

        fetchArticles();
    }, []);

    const handleDelete = async (articleId: string) => {
        if (window.confirm('Are you sure you want to delete this article?')) {
            try {
                await apiHelper.deleteArticle(articleId);
                setArticles(articles.filter(article => article.articleId !== articleId));
            } catch (err) {
                alert('Failed to delete article');
            }
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    return (
        <div className="article-list-container">
            <h1>Article List</h1>
            <table className="article-list-table">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Title</th>
                        <th>Image</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {articles.map(article => (
                        <tr key={article.articleId}>
                            <td>{article.articleId}</td>
                            <td>{article.title}</td>
                            <td>
                                {(article.mainImageUrl != null) &&
                                    <img style={{ width: "50px" }} src={article.mainImageUrl} alt='article image' />}
                            </td>
                            <td className="article-list-actions">
                                <button onClick={() => navigate(`/admin/editarticle/${article.articleId}`)}>Edit</button>
                                <button onClick={() => navigate(`/admin/manageimages/${article.articleId}`)}>Manage Images</button>
                                <button onClick={() => handleDelete(article.articleId)}>Delete</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ArticleList;